<template>
<div>
    <b-input-group class="filter-group">
      <b-input-group-prepend is-text>
          <font-awesome-icon icon="search" />
      </b-input-group-prepend>
      <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
      <b-input-group-append>
          <b-button @click="filter = null">Clear</b-button>
      </b-input-group-append>
    </b-input-group>

    <b-table striped
          hover
          :items="opportunities"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          @filtered="onFiltered"
          :sort-compare="customSort"
          >
      <template slot="lastName" slot-scope="data">
        {{ data.item.student.lastName }}
      </template>    
      <template slot="firstName" slot-scope="data">
        {{ data.item.student.firstName }}
      </template>
      <template slot="name" slot-scope="data">
        {{ data.item.opportunity.name }}
      </template>
      <template slot="category" slot-scope="data">
        {{ data.item.opportunity.opportunityCategory ? data.item.opportunity.opportunityCategory.name : "" }}
      </template>
      <template slot="site" slot-scope="data">
        {{ data.item.opportunity.site.name }}
      </template>
      <template slot="term" slot-scope="data">
        {{ data.item.opportunity.term.description }}
      </template>
      <template slot="primarySelection" slot-scope="data">
        {{ data.item.primarySelection | trueOrFalse }}
      </template>
      <template slot="details" slot-scope="data">
        <router-link :to="{ name: 'studentOpportunityDetails', params: { studentOpportunityId: data.item.studentOpportunityId } }">View</router-link> 
      </template>
    </b-table>

    <b-pagination :total-rows="totalRows" v-model="currentPage" :per-page="perPage" align="right" />
</div>
</template>

<script>
import { mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
// import opportunitiesApi from "../../api/placements/opportunities";
export default {
  data() {
    return {
      sortBy: "lastName",
      sortDesc: false,
      student: null,
      fields: [
        { key: "lastName", sortable: true },
        { key: "firstName", sortable: true },
        { key: "name", label: "Name / Title", sortable: true },
        { key: "category", sortable: true },
        { key: "site", sortable: true },
        { key: "term", sortable: true },
        { key: "primarySelection", sortable: true },
        { key: "details", sortable: false }
      ],
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: null
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    })
  },

  props: {
    opportunities: {
      type: Array,
      required: true
    }
  },

  methods: {
    customSort(a, b, key) {
      var categoryNameA;
      var categoryNameB;

      if (key === "firstName") {
        categoryNameA = a.student.firstName ? a.student.firstName : "";
        categoryNameB = b.student.firstName ? b.student.firstName : "";

        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "lastName") {
        categoryNameA = a.student.lastName ? a.student.lastName : "";
        categoryNameB = b.student.lastName ? b.student.lastName : "";

        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "name") {
        categoryNameA = a.opportunity.opportunityCategory
          ? a.opportunity.opportunityCategory.name
          : "";
        categoryNameB = b.opportunity.opportunityCategory
          ? b.opportunity.opportunityCategory.name
          : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "category") {
        categoryNameA = a.opportunity.opportunityCategory
          ? a.opportunity.opportunityCategory.name
          : "";
        categoryNameB = b.opportunity.opportunityCategory
          ? b.opportunity.opportunityCategory.name
          : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "site") {
        categoryNameA = a.opportunity.site ? a.opportunity.site.name : "";
        categoryNameB = b.opportunity.site ? b.opportunity.site.name : "";
        return categoryNameA.localeCompare(categoryNameB);
      }
      if (key === "term") {
        categoryNameA = a.opportunity.term
          ? a.opportunity.term.description
          : "";
        categoryNameB = b.opportunity.term
          ? b.opportunity.term.description
          : "";
        return categoryNameA.localeCompare(categoryNameB);
      } else {
        return null;
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    }
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}
</style>
